import message from 'antd/lib/message'
import CopyIcon from '../../../assets/icons/copy-icon.svg?react'
import ReactDOM from 'react-dom/client'
import { Root } from 'react-dom/client'
import { formatTimeWithMilliseconds } from '../../../common/common.utils'
import videojs from 'video.js'
import Player from 'video.js/dist/types/player'
import styles from '../VideoPlayer.module.less'

export class CopyVideoCurrentTime extends videojs.getComponent('Button') {
    private reactRoot: Root | null = null

    constructor(player: Player, options: object) {
        super(player, options)
        // @ts-ignore
        this.controlText('Copy Timestamp')
    }

    handleClick() {
        const currentTime = this.player().currentTime() ?? 0
        navigator.clipboard
            .writeText(formatTimeWithMilliseconds(currentTime))
            .then(() => {
                message.success('Timestamp Copied')
            })
            .catch(() => {
                message.error('Failed to Copy Timestamp')
            })
    }

    createEl() {
        const el = super.createEl()
        this.reactRoot = ReactDOM.createRoot(el)
        this.reactRoot.render(
            <div className={styles['vjs-custom-button']}>
                <CopyIcon />
            </div>
        )
        return el
    }

    dispose() {
        if (this.reactRoot) {
            this.reactRoot.unmount()
            this.reactRoot = null
        }
        super.dispose()
    }
}
